// 10 services avec descriptions SEO uniques
export const SERVICES = [
  {
    slug: "degraissage-hotte-restaurant",
    title: "Dégraissage Hotte Restaurant",
    short: "Dégraissage complet de hottes de restaurant aux normes incendie.",
    icon: "Flame",
    intro:
      "Le dégraissage de hotte de restaurant est une obligation légale issue de l'arrêté du 25 juin 1980. Nous effectuons un dégraissage complet : démontage des filtres, lavage haute pression, dégraissage chimique de la hotte intérieure et extérieure, nettoyage du caisson d'extraction.",
    details: [
      "Démontage et nettoyage haute pression des filtres à graisse",
      "Dégraissage chimique de la hotte intérieure (parois, plafond, joints)",
      "Nettoyage de la hotte extérieure et habillage inox",
      "Vérification des dispositifs d'arrêt d'urgence et coupe-feu",
      "Remise d'un certificat conforme arrêté du 25 juin 1980",
    ],
    keywords: "dégraissage hotte restaurant, hotte restaurant normes, dégraissage incendie restaurant",
  },
  {
    slug: "nettoyage-hotte-professionnelle",
    title: "Nettoyage Hotte Professionnelle",
    short: "Nettoyage minutieux des hottes professionnelles toutes marques.",
    icon: "Sparkles",
    intro:
      "Nettoyage haute pression et dégraissage intégral des hottes professionnelles toutes marques (Halton, Bonnet, Charvet, Capic). Notre équipe technique intervient sur tout type de hotte : murale, centrale, à induction, à compensation d'air, avec récupération d'énergie.",
    details: [
      "Diagnostic complet avec photos avant intervention",
      "Nettoyage à la vapeur et produit dégraissant professionnel",
      "Polissage et brillance de la finition inox",
      "Contrôle de l'éclairage et des spots intégrés",
      "Photo après et rapport d'intervention complet",
    ],
    keywords: "nettoyage hotte professionnelle, hotte Halton, nettoyage hotte Bonnet",
  },
  {
    slug: "nettoyage-extraction-cuisine",
    title: "Nettoyage Extraction Cuisine",
    short: "Nettoyage complet du système d'extraction d'une cuisine professionnelle.",
    icon: "Wind",
    intro:
      "Le système d'extraction d'une cuisine professionnelle comprend la hotte, les gaines, le caisson d'extraction et le rejet en toiture. Nous nettoyons l'ensemble pour prévenir les risques incendie, garantir le tirage et respecter les normes d'hygiène.",
    details: [
      "Nettoyage haute pression de toute la longueur de gaine",
      "Démontage caisson d'extraction et nettoyage turbine",
      "Vérification étanchéité et trappes de visite",
      "Nettoyage du rejet en toiture et de la sortie d'air",
      "Test de débit et rapport d'intervention",
    ],
    keywords: "nettoyage extraction cuisine, système extraction restaurant, ventilation cuisine pro",
  },
  {
    slug: "nettoyage-gaine-ventilation",
    title: "Nettoyage Gaine de Ventilation",
    short: "Décrassage haute pression de toutes les gaines de ventilation.",
    icon: "AirVent",
    intro:
      "Les gaines de ventilation et d'extraction accumulent graisse, suie et résidus de cuisson. Sans nettoyage régulier, elles deviennent un foyer d'incendie majeur. Nous décrassons mécaniquement et chimiquement toute la longueur de gaine.",
    details: [
      "Décrassage mécanique par brossage rotatif haute pression",
      "Nettoyage chimique avec dégraissant alimentaire homologué",
      "Inspection vidéo endoscopique des conduits",
      "Création de trappes de visite si nécessaire",
      "Attestation de conformité PV3 / arrêté 25/06/1980",
    ],
    keywords: "nettoyage gaine ventilation, décrassage gaine extraction, gaine restaurant",
  },
  {
    slug: "nettoyage-vmc-restaurant",
    title: "Nettoyage VMC Restaurant",
    short: "Maintenance et nettoyage des VMC de restaurant et salle.",
    icon: "Fan",
    intro:
      "La VMC (Ventilation Mécanique Contrôlée) d'un restaurant assure le renouvellement d'air en cuisine et en salle. Un nettoyage régulier garantit la qualité de l'air, le confort des clients et le bon fonctionnement du système.",
    details: [
      "Nettoyage des bouches d'extraction et d'insufflation",
      "Démontage et nettoyage du moteur VMC",
      "Nettoyage des conduits et caissons",
      "Mesure de débit et équilibrage",
      "Rapport d'intervention détaillé",
    ],
    keywords: "nettoyage VMC restaurant, maintenance VMC, VMC cuisine",
  },
  {
    slug: "entretien-hotte-cuisine-professionnelle",
    title: "Entretien Hotte Cuisine Professionnelle",
    short: "Contrat d'entretien régulier (2 à 4 passages/an).",
    icon: "Calendar",
    intro:
      "Souscrivez un contrat d'entretien régulier pour votre hotte de cuisine professionnelle. Selon votre activité, nous programmons 2 à 4 interventions par an pour garantir une conformité permanente et un coût optimisé.",
    details: [
      "Contrat sur mesure adapté à votre activité",
      "Planification automatique des interventions",
      "Tarif préférentiel pour clients sous contrat",
      "Attestation systématique après chaque passage",
      "Suivi digital avec historique des interventions",
    ],
    keywords: "contrat entretien hotte, maintenance hotte cuisine, entretien annuel hotte",
  },
  {
    slug: "nettoyage-systeme-extraction",
    title: "Nettoyage Système Extraction",
    short: "Nettoyage global du système d'extraction de cuisine pro.",
    icon: "Filter",
    intro:
      "Nettoyage global et coordonné de l'ensemble du système d'extraction de votre cuisine professionnelle. De la hotte jusqu'au rejet, nous traitons chaque élément pour assurer une efficacité maximale et une sécurité optimale.",
    details: [
      "Audit complet du système (hotte, gaine, moteur, rejet)",
      "Plan d'intervention coordonné",
      "Démontage, nettoyage, remontage et tests",
      "Mise aux normes si nécessaire",
      "Garantie 3 mois sur l'intervention",
    ],
    keywords: "nettoyage système extraction, système ventilation restaurant, extraction complète",
  },
  {
    slug: "degraissage-cuisine-professionnelle",
    title: "Dégraissage Cuisine Professionnelle",
    short: "Dégraissage complet d'une cuisine professionnelle.",
    icon: "ChefHat",
    intro:
      "Au-delà de la hotte, nous dégraissons l'ensemble de votre cuisine professionnelle : plans de travail, murs, sols, équipements de cuisson. Idéal pour la remise en état avant ouverture, après sinistre ou avant un contrôle sanitaire.",
    details: [
      "Dégraissage des murs, sols et plafonds",
      "Nettoyage des plans de travail et plonges",
      "Décrassage des équipements de cuisson",
      "Désinfection alimentaire après dégraissage",
      "Idéal pour remise en état ou pré-contrôle DDPP",
    ],
    keywords: "dégraissage cuisine professionnelle, nettoyage cuisine restaurant, dégraissage complet",
  },
  {
    slug: "nettoyage-conduit-hotte",
    title: "Nettoyage Conduit Hotte",
    short: "Décrassage des conduits et carneaux verticaux.",
    icon: "Pipette",
    intro:
      "Les conduits verticaux qui traversent les étages d'un immeuble accumulent les graisses les plus dangereuses. Nous intervenons avec un matériel spécialisé pour décrasser ces conduits difficiles d'accès en respectant la copropriété.",
    details: [
      "Démontage des trappes d'accès en gaine technique",
      "Décrassage mécanique sur toute la hauteur",
      "Caméra endoscopique pour contrôle qualité",
      "Création de trappes supplémentaires si besoin",
      "Coordination avec syndic / copropriété",
    ],
    keywords: "nettoyage conduit hotte, conduit vertical restaurant, carneau cuisine",
  },
  {
    slug: "nettoyage-ventilation-restaurant",
    title: "Nettoyage Ventilation Restaurant",
    short: "Nettoyage global de la ventilation d'un restaurant.",
    icon: "WindArrowDown",
    intro:
      "La ventilation d'un restaurant comprend l'extraction de cuisine, la VMC de salle, l'amenée d'air neuf et parfois la climatisation. Nous proposons un nettoyage global coordonné pour optimiser la qualité de l'air et l'efficacité énergétique.",
    details: [
      "Nettoyage extraction cuisine + VMC salle",
      "Nettoyage amenée d'air neuf",
      "Nettoyage des grilles, diffuseurs et caissons",
      "Désinfection et traitement anti-bactérien",
      "Rapport d'intervention complet et photos",
    ],
    keywords: "nettoyage ventilation restaurant, aération restaurant, ventilation cuisine pro",
  },
];

export const findServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
